import requestInstance from "./Request";

// Adjust the base URL as per your environment
let env = process.env.REACT_APP_B2B_API_BASE_URL

// GET Vendor Compliance Expiry Tracker
export const getVendorComplianceExpiryTracker = async ({
  complianceType = "subVendorRegistration",
  status = "",
  dateFrom = "",
  dateTo = "",
  page,
  pageSize,
  location = ""
} = {}) => {
  try {
    const response = await requestInstance.get(
      `${env}/admin-api/v3/expiring-compliances`, 
      {
        params: {
          complianceType,
          status,
          dateFrom,
          dateTo,
          page,
          pageSize,
          location,
          isB2B: 'true'
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching Vendor Compliance Expiry Tracker:", error);
    throw error;
  }
};